import * as React from 'react'
import {compose, graphql, withApollo} from 'react-apollo'
import Header from '../../components/Header/Header'
import MobileBottomNav from '../../components/MobileBottomNav/MobileBottomNav'
import {
  currentUserRolesQuery,
  getEmployeeDetailsFromIAM,
} from '../../queries/employeeQuery'
import RouteHandler from './RouteHandler'
import Loader from '../../components/common/Loader/Loader'
import {IProps} from './RouteContainer.d'
import {writeToCache} from '../../utils/graphQLUtils'
import {targetPropTypes} from '../../commonPropsType'
import {mappingtargetId} from './utils.RouteContainer'
import {withContext} from 'recompose'
import {SearchContext, searchState, searchReducer} from '../Search/utils.search'
import {newsTargetGroupQuery} from '../../queries/newsTargetGroupQuery'
import {getUserProfileInfo} from '../../queries/userProfileQuery'
import './routeContainer.scss'
import CookieConsentWrapper from '../../components/common/CookieConsentWrapper/CookieConsentWrapper'
import {getCookie, checkObjProps, isMobile} from '../../utils/genericUtils'
import {getLoginAsInfoFromCookie} from '../../utils/cookieUtils'
import MobileBottomNavWrapper from '../../components/MobileBottomNav/MobileBottomNavWrapper'

const RouteContainer = (props: IProps) => {
  const {targetLoading = false, userLoading = false, employee} = props
  const [searchData, dispatchToSearch] = React.useReducer(
    searchReducer,
    searchState
  )

  React.useEffect(() => {
    if (employee) {
      writeToCache(employee)
    }
  }, [employee])

  return (
    <div>
      {targetLoading || userLoading ? (
        <Loader />
      ) : (
        !!employee && (
          <div className="route-container">
            <SearchContext.Provider value={{searchData, dispatchToSearch}}>
              <Header />
              <RouteHandler employee={employee} />
              {isMobile() && <MobileBottomNavWrapper employee={employee} />}
              <CookieConsentWrapper citrixId={employee.sixtId} />
            </SearchContext.Provider>
          </div>
        )
      )}
    </div>
  )
}

const withTargetContext = withContext(targetPropTypes, (props: any) => {
  const {employee, isInfluencer} = props
  const {profilePhotoURL = '', name = ''} = props.adfsUserInfo || {}

  const defaultTarget = (props.tIds && props.tIds.Franchise) || '52'
  const regionIdentifier = ''
  const citrixId = employee?.sixtId || ''
  const email = employee?.email || ''
  const contractCountry = employee?.country || ''

  const adfsUserInfo = {profilePhotoURL, name}
  const loginAsInfo = getLoginAsInfoFromCookie()
  const additionalTargets = []
  const userInfo = getCookie('loginUserInfo')
  const decodedUserInfo = JSON.parse(decodeURIComponent(userInfo))
  const emailFromLogin = decodedUserInfo.emailId || ''

  return {
    citrixId: loginAsInfo.citrixId || citrixId,
    email: loginAsInfo.email || emailFromLogin || email,
    defaultTarget,
    regionIdentifier,
    adfsUserInfo,
    additionalTargets,
    contractCountry,
    isInfluencer,
  }
})

export default compose(
  withApollo,
  graphql(newsTargetGroupQuery, {
    props: ({data: {taxonomyTermQuery = {}, loading}}: any) => {
      const tIds = {}
      if (taxonomyTermQuery && taxonomyTermQuery.entities) {
        taxonomyTermQuery.entities
          .filter(entity => entity !== null)
          .forEach((item: any) => {
            if (item) {
              tIds[item.entityLabel] = item.entityId
            }
          })
      }
      return {tIds, targetLoading: loading}
    },
  }),
  graphql(getUserProfileInfo, {
    options: (props: any) => {
      const userInfo = getCookie('loginUserInfo')
      let emailId = getLoginAsInfoFromCookie().email
      if (!emailId && userInfo && decodeURIComponent(userInfo)) {
        emailId = JSON.parse(decodeURIComponent(userInfo)).emailId
      }
      return {variables: {emailIdList: [emailId]}}
    },
    props: ({data: {error, loading, getBulkUserProfileInfo}}: any) => {
      return {
        dataError: error,
        userLoading: loading,
        adfsUserInfo: checkObjProps(getBulkUserProfileInfo, ['0'], ''),
      }
    },
  }),
  graphql(getEmployeeDetailsFromIAM, {
    options: () => {
      const isLoggednIn = getLoginAsInfoFromCookie().citrixId
      const userInfo = isLoggednIn
        ? isLoggednIn
        : JSON.parse(decodeURIComponent(getCookie('loginUserInfo'))).userId
      return {variables: {empId: userInfo}}
    },
    props: ({data}: any) => {
      const {error, loading} = data
      return {
        employee: data.getEmployeeDetailsFromIAM,
        dataError: error,
        userLoading: loading,
      }
    },
  }),
  graphql(currentUserRolesQuery, {
    props: ({data}: any) => {
      const {loading, currentUserContext = {}} = data
      const currentUserRoles = checkObjProps(
        currentUserContext,
        ['roles'],
        []
      ).map(role => role.targetId)
      return {
        isInfluencer: currentUserRoles.includes('sixt_voice'),
        userLoading: loading,
      }
    },
  }),
  withTargetContext
)(RouteContainer)
